<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="container-fluid pt-custom pb-5 ">
        <!-- onclick="outerbody();" -->
        <div class="row">
            <div class="col-lg-12">
                <div class="header">
                    <h4 class="title">College Master</h4>
                </div>
                <div class="row justify-content-center card">
                    <div class="col-lg-12 col-md-12 col-12 p-4">
                        <form #collegeForm="ngForm" (ngSubmit)="onSubmit(data)" class="pb-3">
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College name</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #CollegeName="ngModel" ngModel
                                        name="CollegeName" [(ngModel)]="data.CollegeName" maxlength="200"
                                        placeholder="Enter college name" required>
                                    <span *ngIf="collegeForm.submitted && CollegeName.invalid">
                                        <p *ngIf="CollegeName.errors.required" class="error_message"
                                            style="color: red;">
                                            College name is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College code</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #CollegeCode="ngModel" ngModel
                                        name="CollegeCode" [(ngModel)]="data.CollegeCode" maxlength="200"
                                        placeholder="Enter college code" required>
                                    <span *ngIf="collegeForm.submitted && CollegeCode.invalid">
                                        <p *ngIf="CollegeCode.errors.required" class="error_message"
                                            style="color: red;">
                                            College code is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Trust name</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #TrustName="ngModel" ngModel
                                        name="TrustName" [(ngModel)]="data.TrustName" maxlength="200"
                                        placeholder="Enter trust name" required>
                                    <span *ngIf="collegeForm.submitted && TrustName.invalid">
                                        <p *ngIf="TrustName.errors.required" class="error_message" style="color: red;">
                                            Trust name is required
                                        </p>
                                    </span>
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College address</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #Address="ngModel" ngModel name="Address"
                                        [(ngModel)]="data.Address" maxlength="300" placeholder="Enter college address"
                                        (keypress)="blockSpecialChar($event)" required>
                                    <span *ngIf="collegeForm.submitted && Address.invalid">
                                        <p *ngIf="Address.errors.required" class="error_message" style="color: red;">
                                            College address is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>State</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #StateID="ngModel" ngModel name="StateID"
                                        (change)="fillCity()" [(ngModel)]="data.StateID" required>
                                        <option *ngFor="let state of states" [value]="state.value"
                                            [selected]="data.StateID == state.value">
                                            {{ state.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="collegeForm.submitted ">
                                        <p *ngIf="data.StateID == 0 || data.StateID == undefined"
                                            class="error_message" style="color: red;">
                                            State is required
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>City</b><span class="text-danger">*</span></label>
                                    <select class="form-control" #CityID="ngModel" ngModel name="CityID"
                                        [(ngModel)]="data.CityID" required>
                                        <option *ngFor="let city of cities" [value]="city.value"
                                            [selected]="data.CityID == city.value">
                                            {{ city.text }}
                                        </option>
                                    </select>
                                    <span *ngIf="collegeForm.submitted ">
                                        <p *ngIf="data.CityID == 0 || data.CityID == undefined"
                                            class="error_message" style="color: red;">
                                            City is required
                                        </p>
                                    </span>
                                </div>
                              
                            </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Pincode</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #Pincode="ngModel" ngModel name="Pincode"
                                        [(ngModel)]="data.Pincode" numbersOnly maxlength="10"
                                        placeholder="Enter pincode" required>
                                    <span *ngIf="collegeForm.submitted && Pincode.invalid">
                                        <p *ngIf="Pincode.errors.required" class="error_message" style="color: red;">
                                            Pincode is required
                                        </p>
                                      
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>Contact / mobile no.</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #MobileNo="ngModel" ngModel name="MobileNo"
                                        [(ngModel)]="data.MobileNo" minlength="10" numbersOnly maxlength="10"
                                        placeholder="Enter contact / mobile no." required>
                                    <span *ngIf="collegeForm.submitted && MobileNo.invalid">
                                        <p *ngIf="MobileNo.errors.required" class="error_message" style="color: red;">
                                            Contact / mobile no. is required
                                        </p>
                                        <p *ngIf="MobileNo.errors.minlength" class="error_message" style="color: red;">
                                            Contact / mobile no. must be of 10 digit
                                        </p>
                                        <p *ngIf="MobileNo.errors.maxlength" class="error_message" style="color: red;">
                                            Contact / mobile no. must be of maximun 10 digit
                                        </p>
                                    </span>
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College mail id</b><span class="text-danger">*</span></label>
                                    <input type="text" class="form-control" #MailID="ngModel" ngModel name="MailID"
                                        [(ngModel)]="data.MailID" maxlength="50"
                                        pattern="^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+$" placeholder="Enter college mail id"
                                        required>
                                    <span *ngIf="collegeForm.submitted && MailID.invalid">
                                        <p *ngIf="MailID.errors.required" class="error_message" style="color: red;">
                                            College mail id is required
                                        </p>
                                        <p *ngIf="MailID.errors.pattern" class="error_message" style="color: red;">
                                            College mail id is invalid
                                        </p>
                                    </span>
                                </div>
                                </div>
                            <div class="row mt-2">
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College location</b></label>
                                    <select class="form-control" #Location="ngModel" ngModel name="Location"
                                        [(ngModel)]="data.Location">
                                        <option *ngFor="let location of locations" [value]="location.value"
                                            [selected]="data.Location == location.value">
                                            {{ location.text }}
                                        </option>
                                    </select>
                                    <!-- <span *ngIf="collegeForm.submitted ">
                                        <p *ngIf="data.Location == 0 || data.Location == undefined"
                                            class="error_message" style="color: red;">
                                            College location is required
                                        </p>
                                    </span> -->
                                </div>
                                <div class="form-group col-lg-4 col-md-12 col-12">
                                    <label><b>College type</b></label>
                                    <select class="form-control" #Type="ngModel" ngModel name="Type"
                                        [(ngModel)]="data.Type" required>
                                        <option *ngFor="let type of types" [value]="type.value"
                                            [selected]="data.Type == type.value">
                                            {{ type.text }}
                                        </option>
                                    </select>
                                    <!-- <span *ngIf="collegeForm.submitted ">
                                        <p *ngIf="data.Type == 0 || data.Type == undefined" class="error_message"
                                            style="color: red;">
                                            College type is required
                                        </p>
                                    </span> -->
                                </div>
                            </div>

                            <div class="mb-3">
                                <button class="btn btn-success" type="submit"
                                    style="margin: 5px;">{{btnsubmittext}}</button>
                                <button class="btn btn-primary" type="button" (click)="resetForm()"
                                    style="margin: 5px;">Clear</button>
                            </div>
                        </form>
                        <div class="row">
                            <div class="col-lg-12 col-md-12 col-12">
                                <div class="table-responsive subject">
                                    <div class="col-lg-12 col-md-12 col-12">
                                        <div class="row">
                                            <div class="col-md-11">
                                                <div class="py-3">
                                                    <input type="text" id="searchtext"
                                                        class="form-control bg-white border-0 small"
                                                        placeholder="Search for..." [(ngModel)]="searchtext"
                                                        aria-label="Search" aria-describedby="basic-addon2"
                                                        />
                                                </div>
                                            </div>
                                            <div class="col-md-1">
                                                <div class="py-3">
                                                    <button class="btn btn-success" (click)="getCollegeList(1);"
                                                        style="margin: 5px;">Search</button>
                                                </div>
                                            </div>
                                        </div>
                                        <table id="example" class="table table-striped table-bordered"
                                            style="width:100%">
                                            <thead>
                                                <tr>
                                                    <th class="pointer" scope="col" (click)="sortBy('SrNo')">Sr. No.
                                                    </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('CollegeName')">
                                                        College Name </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('CollegeCode')">
                                                        College Code </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('TrustName')">
                                                        Trust Name </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('Address')">Address
                                                    </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('MobileNo')">
                                                        Mobile No </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('MailID')">Mail ID
                                                    </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('LocationName')">
                                                        Location Name
                                                    </th>
                                                    <th class="pointer" scope="col" (click)="sortBy('TypeName')">Type
                                                        Name
                                                    </th>
                                                    <th class="pointer" scope="col">Action</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngIf="collegeList != undefined && collegeList.length != 0">
                                                <tr
                                                    *ngFor="let r of collegeList | paginate: { itemsPerPage: pageLimit,currentPage: p ,totalItems: totalCollege};let i = index">
                                                    <td>{{r.SrNo}}</td>
                                                    <td>
                                                        <p>{{r.CollegeName}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.CollegeCode}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.TrustName}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.Address}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.MobileNo}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.MailID}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.LocationName}}</p>
                                                    </td>
                                                    <td>
                                                        <p>{{r.TypeName}}</p>
                                                    </td>
                                                    <td>
                                                        <!-- <div *ngIf="r.status == 'Not Approved'"> -->
                                                        <button type="button" class="btn btn-success rmb_10"
                                                            (click)="editCollege(r.HashCode)">Edit</button>
                                                        &nbsp; <button type="button" class="btn btn-danger"
                                                            (click)="deleteCollege(r.HashCode)">Delete</button>
                                                        <!-- </div> -->
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tbody
                                            *ngIf="collegeList == undefined || collegeList.length == 0">
                                            <tr>
                                                <td colspan="10" style="text-align: center;">
                                                    No record found
                                                </td>
                                            </tr>
                                        </tbody>
                                        </table>
                                        <div class="card-footer pb-0 pt-3" align="right">
                                            <pagination-controls (pageChange)="getCollegeList($event)" responsive="true"
                                            maxSize="{{totalPages}}"></pagination-controls>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="footer-login custom-footer">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
    <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
        <p style="color: white;">Please Wait.</p>
    </ngx-spinner>
</div>